// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Bazar";
export const BZ2_EDIT_PRODUCT = "\u00daprava inzer\u00e1tu";
export const EDIT_PRODUCT_SUBMIT_BUTTON = "Ulo\u017e inzer\u00e1t";
